






























import { Component, PropSync, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

@Component
export default class SwapSetGroup extends Vue {
  @PropSync('ruleForm', { type: Object }) syncedRuleForm!: any;
  @PropSync('currentActive', { type: Number }) syncedCurrentActive!: number;

  @Action('getGroups', { namespace: 'manageGroup' }) c_getGroups!: any;
  @Action('createLab', { namespace: 'manageGroup' }) c_createLab!: any;

  @Getter('getterGroupsMemberships', { namespace: 'manageGroup' }) c_getterGroupsMemberships!: any;

  public isLoading: boolean = false;

  async createLab(): Promise<any> {
    try {
      this.isLoading = true;
      this.syncedRuleForm.members = this.syncedRuleForm.members.filter((member: any) => {
        return member.email !== '';
      });
      await this.c_createLab(this.syncedRuleForm);
      this.isLoading = false;
      this.modalClose();
      this.$message.success('LAB을 만들었습니다.');
      this.$root.$emit('createGroup', false);
      await this.c_getGroups();
      await this.$router.push({
        name: 'ContentView',
        params: {
          groupId: this.c_getterGroupsMemberships[this.c_getterGroupsMemberships.length - 1].fkGroup
            .id,
        },
      });
    } catch (e) {
      this.isLoading = false;
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  modalClose() {
    this.$root.$emit('closeCreateLab', false);
  }
}
